/*
 * @author : Augusto Monteiro
 * @email  : augustomna2010@gmail.com
 * @augustomna2010
 */

import { getPositionSourceName } from "react/utils/coordinateUtils";
import { EquipmentStatusCaption } from "react/components/TrackEquipmentMapsDisplay/EquipmentStatusCaption";
import { CustomProvider, renderComponent } from "react/utils/renderUtils";
import { checkPermissions } from "react/utils/utils";

Greenmile.Templates = {

    getSignatureContainer: function (data) {
        const signaturePopupContainer = document.createElement('div'),
            infoContainer             = document.createElement('div'),
            signatureContainer        = document.createElement('div'),
            canvasContainer           = document.createElement('canvas'),
            image                     = new Image();

        signaturePopupContainer.className = 'signaturePopupContainer popup_signature';
        infoContainer.className = 'infoContainer';
        signatureContainer.className = 'signatureContainer';

        image.src = 'data:image/jpeg;charset=utf-8;base64,' + data.signatureImageAsBase64;
        image.onload = () => {
          const canvasCtx = canvasContainer.getContext('2d');
          const MAX_WIDTH = 900;
          const MAX_HEIGHT = 675;
          let width = image.width;
          let height = image.height;

          if (width > height && width > MAX_WIDTH) {
            height *= MAX_WIDTH / width;
            width = MAX_WIDTH;
          } else if (height > MAX_HEIGHT) {
            width *= MAX_HEIGHT / height;
            height = MAX_HEIGHT;
          }

          width = parseInt(width, 10);
          height = parseInt(height, 10);

          canvasContainer.width = width;
          canvasContainer.height = height;
          canvasCtx.drawImage(image, 0, 0, width, height);
        }

        signatureContainer.appendChild(canvasContainer);
        signaturePopupContainer.appendChild(signatureContainer);
        signaturePopupContainer.appendChild(this.generateSignatureInfoContainer(data));

        return signaturePopupContainer;
    },

    generateSignatureInfoContainer: function (data) {
        const stop = data.stop;
        const stopSignature = data.stopSignature;
        const accuracy = new Monet.Format.METERS_OR_FEET(stopSignature.accuracyMeters).toGrid().getValue(),
              actualArrival = new Monet.Format.DATE_TIME(stop.actualArrival).toGrid().getValue(),
              actualDeparture = new Monet.Format.DATE_TIME(stop.actualDeparture).toGrid().getValue(),
              routeDate = new Monet.Format.DATE(stop.route.date).toGrid().getValue(),
              latitude = stopSignature.latitude ? stopSignature.latitude : ' - ',
              longitude = stopSignature.longitude ? stopSignature.longitude : ' - ',
              drivers = (data.driversAssigned || []).map(({ driver: { name }}) => name ).join(', ');

        const firstColumn = [
            { label: 'Signature.consignee', value: stopSignature.name },
            { label: 'Signature.location.key', value: stop?.location?.key },
            { label: 'Signature.location.description', value: stop?.location?.description },
            { label: 'Signature.latlong', value: `${latitude}, ${longitude}` },
            { label: 'Signature.actualArrival', value: actualArrival },
            { label: 'Signature.actualDeparture', value: actualDeparture }
        ];

        const secondColumn = [
            { label: 'Signature.organization.key', value: stop.route.organization.key },
            { label: 'Signature.route.key', value: stop.route.key },
            { label: 'Signature.route.date', value: routeDate },
            { label: 'Signature.drivers', value: drivers },
            { label: 'Signature.accuracy', value: accuracy },
            { label: 'Signature.hashCode', value: stopSignature.hashCode, options: { showCopy: true } }
        ];

        const infoContainer = document.createElement('div');
        infoContainer.className = 'infoContainer';
        infoContainer.appendChild(this.generateInfoColumn(firstColumn));
        infoContainer.appendChild(this.generateInfoColumn(secondColumn));
        return infoContainer;
    },

    generateInfoColumn: function (sectionColumn) {
        const table = document.createElement('table');
        sectionColumn.forEach((item) => {
            const tableRow = document.createElement('tr');
            const labelContainer = document.createElement('td');
            labelContainer.className = 'bold_title';
            labelContainer.innerText = Monet.I18n.getResourcesByKey(item.label).replace(/: |:/g,'') + ':';
            tableRow.appendChild(labelContainer);
            tableRow.appendChild(this.generateValueContainer(item));
            table.appendChild(tableRow);
        });
        return table;
    },

    generateValueContainer: function ({ value, options }) {
        const valueContainer = document.createElement('td');
        if (options && options.showCopy) {
            const valueText = document.createElement('div');
            valueText.innerText = value.length > 20 ? `${value.substr(0, 16)}...${value.substr(value.length - 4, value.length)}` : value;
            const copyButton = document.createElement('div');
            copyButton.className = 'icon copy green';
            const successIcon = document.createElement('object');
            successIcon.type = 'image/svg+xml';
            successIcon.data = '/static/images/animated-check-green.svg';
            successIcon.className = 'icon hide';
            copyButton.addEventListener('click', () => {
                navigator.clipboard.writeText(value);
                successIcon.classList.remove('hide');
                copyButton.classList.add('hide');
                setTimeout(() => {
                    successIcon.classList.add('hide');
                    copyButton.classList.remove('hide');
                }, 1500);
            });

            valueContainer.className = 'canCopy';
            valueContainer.appendChild(valueText);
            valueContainer.appendChild(copyButton);
            valueContainer.appendChild(successIcon);
        } else {
            valueContainer.innerText = value || '-';
        }
        return valueContainer;
    },

    generateModalElement: (parentContainer1, parentContainer2, resourceString, data) => {
        const title = document.createElement("span");
        title.className = 'bold_title';
        title.appendChild(document.createTextNode(resourceString));

        parentContainer1.appendChild(title);
        parentContainer2.appendChild(document.createTextNode(data));
    },

    getCaptionArrowStatusTruck: function () {
        const caption = document.createElement("div");
        caption.id = "track-equipment-caption";

        renderComponent(
            <CustomProvider>
                <EquipmentStatusCaption /> 
            </CustomProvider>,
            caption
        );

        return caption;
    },


    getContentSmartGeocodeDetail: function () {

        var layout = {
            "items": [
                {
                    "items": [
                        {
                            "attributes": {
                                "id": "mapToolbar"
                            }
                        },
                        {
                            "attributes": {
                                "id": "smartGeocodeMap"
                            }
                        }
                    ],
                    "attributes": {
                        "id": "adjustsLayoutContainer"
                    }
                },
                {
                    "items": [
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "save",
                                "name": "save",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.save"),
                                "class": "i18nResource"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "saveAndNext",
                                "name": "saveAndNext",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.saveAndNext"),
                                "class": "i18nResource"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "reject",
                                "name": "reject",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.reject"),
                                "class": "i18nResource"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "rejectAndNext",
                                "name": "rejectAndNext",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.rejectAndNext"),
                                "class": "i18nResource"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "cancel",
                                "name": "rejectAndNext",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.cancel"),
                                "class": "i18nResource btn-secondary"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "previous",
                                "name": "previous",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.previous"),
                                "class": "i18nResource btn-secondary"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "next",
                                "name": "next",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.next"),
                                "class": "i18nResource btn-secondary"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "mapToolBarSmartGeocode buttons"
                    }
                }
            ]
        };

        return (new Monet.UI.LayoutGenerator(layout)).render();
    },

    getSmartGeocodeMapButtonsContainer: function () {

        const mapText = Monet.I18n.getResourcesByKey("SmartGeocode.map.containerText", "{markerIcon}").split("{markerIcon}");

        const layout = {
            "items": [
                {
                    "items": [
                        {
                            "attributes": {
                                "id": "mapToolbar"
                            }
                        },
                        {
                            "attributes": {
                                "id": "smartGeocodeMap"
                            }
                        }
                    ],
                    "attributes": {
                        "id": "adjustsLayoutContainer"
                    }
                },
                {
                    "items": [
                        {
                            "tag": "div",
                            "attributes": {
                                "id": "smartGeocodeToolbarText",
                                "class": "i18nResource"
                            },
                            "items": [
                                {
                                    "tag": "i",
                                    "attributes": {
                                        "class": "fa fa-info-circle"
                                    }
                                },
                                {
                                    "tag": "span",
                                    "html": mapText[0]
                                },
                                {
                                    "tag": "i",
                                    "attributes": {
                                        "class": "fa fa-map-marker"
                                    }
                                },
                                {
                                    "tag": "span",
                                    "html": mapText[1]
                                }
                            ],
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "save",
                                "name": "save",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.save"),
                                "class": "i18nResource"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "saveAndNext",
                                "name": "saveAndNext",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.saveAndNext"),
                                "class": "i18nResource"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "reject",
                                "name": "reject",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.reject"),
                                "class": "i18nResource"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "rejectAndNext",
                                "name": "rejectAndNext",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.rejectAndNext"),
                                "class": "i18nResource"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "cancel",
                                "name": "rejectAndNext",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.cancel"),
                                "class": "i18nResource btn-secondary"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "previous",
                                "name": "previous",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.previous"),
                                "class": "i18nResource btn-secondary"
                            }
                        },
                        {
                            "tag": "input",
                            "attributes": {
                                "type": "submit",
                                "id": "next",
                                "name": "next",
                                "value": Monet.I18n.getResourcesByKey("SmartGeocode.Button.next"),
                                "class": "i18nResource btn-secondary"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "mapToolBarSmartGeocode buttons"
                    }
                }
            ]
        };

        return (new Monet.UI.LayoutGenerator(layout)).render();
    },

    getSmartGeocodeListConteiner: function () {

        return new Monet.UI.LayoutGenerator({
            items: [
                {
                    attributes: {
                        "id": "smartGeocodeListConteiner",
                        "class": "grid_list_template"
                    },
                    items: [
                        {
                            attributes: {
                                "class": "form-vertical gridActions"
                            },
                            items: [{
                                attributes: {
                                    "class": "actions"
                                }
                            }]
                        },
                        {
                            attributes: {
                                "class": "display",
                                "id": "gridSmartGeocode"
                            }
                        }
                    ]
                },
                {
                    attributes: {
                        "id": "smartGeocodeDetail"
                    }
                }
            ]
        }).render();

    },

    templateGridListTemplate: function (data) {
        const titleElements = [
            {
                "html": data.title,
                "attributes": {
                    "class": "titleContainer"
                }
            },
        ];

        data?.subtitle && titleElements.push({
            "html": data.subtitle,
            "attributes": {
                "class": "subtitleContainer"
            }
        });

        const layout = {
            "tag": "div",
            "items": [
                {
                    "items": [
                        {
                            "items": [
                                {
                                    "items": titleElements,
                                    "attributes": {
                                        "class": "leftContainer"
                                    }
                                },
                                {
                                    "attributes": {
                                        "class": "rightContainer"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "gridHeaderContainer"
                            }
                        },
                        {
                            "attributes": {
                                "class": "gridActions ui-widget-header"
                            }
                        },
                        {
                            "attributes": {
                                "class": "display",
                                "id": "grid"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "grid_list_template"
                    }
                }
            ]
        };

        return new Monet.UI.LayoutGenerator(layout).render().innerHTML;
    },

    templateFormLabel: function (data) {
        return new Monet.UI.LayoutGenerator({
            "tag": "div",
            "items": [
                {
                    "items": [
                        {
                            "tag": "label",
                            "items": [
                                {
                                    "tag": "span",
                                    "html": data.label,
                                    "attributes": {
                                        "class": "i18nResource"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "control-label"
                            }
                        },
                        {
                            "items": [
                                {
                                    "tag": "p",
                                    "attributes": {
                                        "class": "help-block"
                                    }
                                }
                            ],
                            "html": data.value,
                            "attributes": {
                                "class": "controls"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "control-group"
                    }
                },
                {
                    "items": [
                        {
                            "tag": "label"
                        }
                    ],
                    "attributes": {
                        "class": "form_section_item"
                    }
                }
            ]
        }).render().innerHTML;
    },

    RouteDetails: function (hasPro) {
        const jsonObj = {
            "items": [
                {
                    "items": [
                        {
                            "attributes": {
                                "id": "routeMapContainer",
                                "class": "mapContainer mapDetail"
                            }
                        },
                        {
                            "attributes": {
                                "id": "mapCon"
                            }
                        },
                        {
                            "attributes": {
                                "class": "detailOfMarker"
                            }
                        },
                        {
                            "items": [
                                {
                                    "items": [
                                        {
                                            "tag": "img",
                                            "attributes": {
                                                "src": require("static/images/map/no_track_info.png")
                                            }
                                        },
                                        {
                                            "html": Monet.I18n.getResourcesByKey("Map.noTrackInfo.Label"),
                                            "attributes": {
                                                "class": "noTackInfoLabel i18nResource"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "noTackInfo",
                                        "style": "display: none;"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "informationStops"
                            }
                        },
                        {
                            "attributes": {
                                "id": "bottomBarContainer"
                            }
                        },
                        {
                            "items": [
                                {
                                    "tag": "ul",
                                    "items": [
                                        {
                                            "tag": "li",
                                            "items": [
                                                {
                                                    "tag": "a",
                                                    "html": Monet.I18n.getResourcesByKey('RouteDetail.tab.grid'),
                                                    "attributes": {
                                                        "href": "#routeDetailGrid"
                                                    }
                                                }
                                            ]
                                        },
                                        checkPermissions("HOS_MAP") ? {
                                            "tag": "li",
                                            "items": [
                                                {
                                                    "tag": "a",
                                                    "html": Monet.I18n.getResourcesByKey('RouteDetail.tab.logBook'),
                                                    "attributes": {
                                                        "href": "#routeDetailChart"
                                                    }
                                                }
                                            ]
                                        } : {},
                                        checkPermissions("HOS_MAP") ? {
                                            "tag": "li",
                                            "items": [
                                                {
                                                    "tag": "a",
                                                    "html": Monet.I18n.getResourcesByKey('RouteDetail.tab.summary'),
                                                    "attributes": {
                                                        "href": "#routeDetailSummaryInformation"
                                                    }
                                                }
                                            ]
                                        } : {},
                                        {
                                            "tag": "li",
                                            "items": [
                                                {
                                                    "tag": "a",
                                                    "html": Monet.I18n.getResourcesByKey('RouteDetail.tab.telematic'),
                                                    "attributes": {
                                                        "href": "#routeDetailTelematic"
                                                    }
                                                }
                                            ]
                                        },
                                    ]
                                },
                                {
                                    "attributes": {
                                        "class": "gridActions"
                                    }
                                },
                                {
                                    "attributes": {
                                        "id": "routeDetailGrid",
                                        "class": "gridStopTable"
                                    }
                                },
                                checkPermissions("HOS_MAP") ? {
                                    "attributes": {
                                        "id": "routeDetailChart"
                                    }
                                } : {},
                                checkPermissions("HOS_MAP") ? {
                                    "attributes": {
                                        "id": "routeDetailSummaryInformation"
                                    }
                                } : {},
                                {
                                    "attributes": {
                                        "id": "routeDetailTelematic"
                                    }
                                },
                            ],
                            "attributes": {
                                "id": "tabsRouteDetail"
                            }
                        },
                        {
                            "attributes": {
                                "id": "btnHideGridStop",
                                "class": "gridStopsHide"
                            }
                        },
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "showFullGrid"
                                    }
                                }
                            ],
                            "attributes": {
                                "id": "miniPlayer",
                                "class": "miniPlayer"
                            }
                        },
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "close"
                                    }
                                },
                                {
                                    "attributes": {
                                        "id": "routeDetailsModalContent"
                                    }
                                }
                            ],
                            "attributes": {
                                "id": "panelContainer",
                            }
                        }
                    ],
                    "attributes": {
                        "class": "containerRouteDetail"
                    }
                }
            ]
        };

        if(hasPro){
          jsonObj.items[0].items.push({
            "attributes": {
              "id": "resequenceHistory",
              "class": "resequenceHistory"
            }
          })

          jsonObj.items[0].items.map( item => {
            if(item.attributes.id === "tabsRouteDetail"){

              item.items.push({
                "attributes": {
                  "id": "routeDetailPRO",
                  "class": "gridResequenceHistory"
                }
              });

              item.items[0].items.push({
                "tag": "li",
                "items": [
                  {
                    "tag": "a",
                    "html": Monet.I18n.getResourcesByKey('RouteDetail.tab.pro'),
                    "attributes": {
                      "href": "#routeDetailPRO"
                    }
                  }
                ]
              })

            }
          })
        }

        return new Monet.UI.LayoutGenerator(jsonObj).render();
    },

    routeCapacity: function (data) {
        return new Monet.UI.LayoutGenerator({
            "tag": "div",
            "items": [
                {
                    "items": [
                        {
                            "items": [
                                {
                                    "attributes": {
                                        "class": "size",
                                        "style": "width: " + data.size + "%"
                                    }
                                }
                            ],
                            "attributes": {
                                "class": "routeCapacityBar"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "menuContainerRouteCapacity"
                    }
                }
            ]
        }).render().innerHTML;
    },

    formCloseEvent: function (data) {
        return new Monet.UI.LayoutGenerator({
            "tag": "div",
            "items": [
                {
                    "items": [
                        {
                            "tag": "form",
                            "items": [
                                {
                                    "tag": "input",
                                    "attributes": {
                                        "type": "checkbox",
                                        "id": "endEvento_" + data._id,
                                        "name": "closeException",
                                        "value": "true",
                                        "style": "margin-top: 0px;"
                                    }
                                },
                                {
                                    "tag": "label",
                                    "html": "notificationPanel.checkCloseEvent",
                                    "attributes": {
                                        "for": "endEvento_" + data._id,
                                        "class": "labelCheck i18nResource"
                                    }
                                },
                                {
                                    "tag": "label",
                                    "html": "notificationPanel.comment",
                                    "attributes": {
                                        "for": "comentario",
                                        "class": "labelComent i18nResource"
                                    }
                                },
                                {
                                    "tag": "textarea",
                                    "attributes": {
                                        "rows": "6",
                                        "cols": "50",
                                        "name": "comment",
                                        "id": "comentario",
                                        "style": "width: 232px; resize: none;"
                                    }
                                },
                                {
                                    "items": [
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "hidden",
                                                "name": "eventLog.id",
                                                "value": data._id
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "name": "closeEvent",
                                                "class": "btnCloseEvent_" + data._id + " btnEvents i18nResource",
                                                "value": "notificationPanel.btnCloseEvent",
                                                "style": "float:right;"
                                            }
                                        },
                                        {
                                            "tag": "input",
                                            "attributes": {
                                                "type": "button",
                                                "name": "hideCloseEvent_exit",
                                                "class": "btnHideCloseEvent_" + data._id + " btnEvents i18nResource",
                                                "value": "notificationPanel.btnShowCancelEvent"
                                            }
                                        }
                                    ],
                                    "attributes": {
                                        "class": "formButtons standard-form-buttons"
                                    }
                                }
                            ],
                            "attributes": {
                                "id": "form_" + data._id
                            }
                        }
                    ],
                    "attributes": {
                        "class": "formCloseEvent"
                    }
                }
            ]
        }).render().innerHTML;
    },

    routeVehicleCapacity: function (data) {
        return new Monet.UI.LayoutGenerator({
            "tag": "div",
            "items": [
                {
                    "items": [
                        {
                            "tag": "table",
                            "items": [
                                {
                                    "tag": "tbody",
                                    "items": [
                                        {
                                            "tag": "tr",
                                            "items": [
                                                {
                                                    "tag": "th"
                                                },
                                                {
                                                    "tag": "th",
                                                    "html": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.route.hint.capacity')
                                                },
                                                {
                                                    "tag": "th",
                                                    "html": Monet.I18n.getResourcesByKey('RouteMonitor.sidebar.route.remaining')
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "tr",
                                            "items": [
                                                {
                                                    "tag": "td",
                                                    "html": (Monet.Session && Monet.Session.Configurations)? Monet.Session.Configurations.size1Alias : ''
                                                },
                                                {
                                                    "tag": "td",
                                                    "html": parseFloat(data.capacity1).toFixed(2)
                                                },
                                                {
                                                    "tag": "td",
                                                    "html": parseFloat(data.remainingCapacity1).toFixed(2)
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "tr",
                                            "items": [
                                                {
                                                    "tag": "td",
                                                    "html": (Monet.Session && Monet.Session.Configurations)? Monet.Session.Configurations.size2Alias : ''
                                                },
                                                {
                                                    "tag": "td",
                                                    "html": parseFloat(data.capacity2).toFixed(2)
                                                },
                                                {
                                                    "tag": "td",
                                                    "html": parseFloat(data.remainingCapacity2).toFixed(2)
                                                }
                                            ]
                                        },
                                        {
                                            "tag": "tr",
                                            "items": [
                                                {
                                                    "tag": "td",
                                                    "html": (Monet.Session && Monet.Session.Configurations)? Monet.Session.Configurations.size3Alias : ''
                                                },
                                                {
                                                    "tag": "td",
                                                    "html": parseFloat(data.capacity3).toFixed(2)
                                                },
                                                {
                                                    "tag": "td",
                                                    "html": parseFloat(data.remainingCapacity3).toFixed(2)
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "attributes": {
                                "class": "capacityTable"
                            }
                        }
                    ],
                    "attributes": {
                        "class": "floatMenuContent"
                    }
                }
            ]
        }).render().innerHTML;
    },

    stopDetailWindow: function (content) {
        var div           = document.createElement("div"),
            windowLabel   = document.createElement("div"),
            span          = document.createElement("span"),
            windowContent = document.createElement("div");

        div.className = "stopDetailWindow";
        windowLabel.className = "windowLabel" + ((content.windowLabelClass) ? content.windowLabelClass : '');
        windowContent.className = "windowContent";

        span.textContent = Monet.I18n.getResourcesByKey(content.span);

        if (content['class']) {
            span.setAttribute('class', content['class']);
        }

        if (typeof content.windowContent === "object") {
            windowContent.appendChild(content.windowContent);
        } else {
            windowContent.textContent = content.windowContent;
        }

        windowLabel.appendChild(span);

        div.appendChild(windowLabel);
        div.appendChild(windowContent);

        return div;
    },


    getLeafletPopUp: function (data) {

        var marker        = data.marker,
            markerEl      = data.markerEl,
            request       = data.request,
            velocityKm    = data.velocityKm,
            driversInfo   = data.driversInfo,
            telematicList = data.telematicList,
            routeStatus = (request.route ? request.route.status : '');

        let lat, lng;
        if (data.markerEl && data.markerEl._latlng) {
            lat = data.markerEl._latlng.lat;
            lng = data.markerEl._latlng.lng;
        } else {
            lat = marker.position.latitude;
            lng = marker.position.longitude;
        }

        // Allow max 20 digits after dot (decimal places)
        const latValues = lat.toString().split(".");
        const lngValues = lng.toString().split(".");
        lat = `${latValues[0]}.${latValues[1].substr(0, 20)}`;
        lng = `${lngValues[0]}.${lngValues[1].substr(0, 20)}`;

        var div               = document.createElement("div"),
            hr                = document.createElement("hr"),
            iconNearLocations = document.createElement("div"),
            style             = '';


        if (request.route && request.currentArrivals.length > 0) {
            style = 'height:230px;';

        } else {
            style = 'height:230px; ';
        }

        if(["ARRIVED_ORIGIN", "COMPLETED"].indexOf(routeStatus) === -1 && markerEl?.kind === "EQUIPMENT"){
            iconNearLocations.className = 'nearLocationIcon';
            iconNearLocations.title = Monet.I18n.getResourcesByKey('RouteSummary.nearLocations.title');

            iconNearLocations.addEventListener('click', (function (data) {
                return function (e) {

                    var nearLocation = new Greenmile.RouteDetail.NearLocations();
                    nearLocation.init(data);

                    // Eu vou fechar o modal clicando no close mesmo, deixo aqui esse comentário
                    // e a missão para o próximo irmão que for trabalhar nessa função de fazer isso
                    // de forma mais elegante.

                    try {
                        e.target.parentElement.parentElement.parentElement.previousElementSibling.click();
                    } catch (e) {
                        console.log('The button I was expecting at map popUp was not present');
                    }


                };
            }(data)));


            div.appendChild(iconNearLocations);
        }

        div.setAttribute('style', style);
        div.className = "routeDetail";

        var appendStrongSpan = function (spanValue) {

            var strong = document.createElement("strong"),
                span   = document.createElement("span");

            span.className = 'i18nResource';
            span.innerHTML = Monet.I18n.getResourcesByKey(spanValue);

            strong.appendChild(span);

            div.appendChild(strong);
        };

        var getBrClearAll = function () {
            var brClearAll = document.createElement('br');
            brClearAll.setAttribute('clear', 'all');
            return brClearAll;
        };

        var getRouteDetailItem = function (labelValue, contentValue) {

            var div        = document.createElement("div"),
                label      = document.createElement("div"),
                span       = document.createElement("span"),
                divContent = document.createElement("div");

            div.className = 'routeDetailItem';
            divContent.className = 'content';
            label.className = 'label';
            span.className = 'i18nResource';
            span.appendChild(document.createTextNode(labelValue));

            label.appendChild(span);
            div.appendChild(label);
            if (typeof contentValue === "string") {
                contentValue = document.createTextNode(contentValue);
            }

            divContent.appendChild(contentValue);
            div.appendChild(divContent);

            return div;

        };

        var getLink = function (id, href, innerText, clickEvent) {
            var link = document.createElement('a');
            link.id = id;
            link.href = href;
            link.innerHTML = innerText;
            link.addEventListener('click', (e) => {
                Monet.Session.TrackEquipmentMaps && (Monet.Session.TrackEquipmentMaps.isComingFromEquipmentLink = true);
             });

            return link;
        };

        if (request.route) {
            appendStrongSpan('Map.Popup.Route.Title');
            div.appendChild(hr);

            var routeItem = null;
            if (request.idIsLink) {
                routeItem = getLink('linkToRoute', "#/maps/route/" + request.route.id + "/details", request.route.key, function () {
                    new App.Routers.RouteDetails().show(request.route.id);
                });

            } else {
                routeItem = request.route.key;
            }

            div.appendChild(getRouteDetailItem(Monet.I18n.getResourcesByKey('Map.Popup.Truck.Route') + ':', routeItem));
            div.appendChild(getRouteDetailItem(Monet.I18n.getResourcesByKey('Map.Popup.Truck.Organization') + ':', document.createTextNode(request.route.organization.description)));
            div.appendChild(getRouteDetailItem(Monet.I18n.getResourcesByKey('Map.Popup.Truck.Data') + ':',
                document.createTextNode(Monet.Format.Date.formatToLocale(request.route.date))));

            var statusContent          = document.createElement('div'),
                statusDelivered        = document.createElement('div'),
                statusBackLater        = document.createElement('div'),
                statusReturn           = document.createElement('div'),
                statusDeliveryProgress = document.createElement('div');

            statusContent.className = 'routeProgressBar';
            statusDelivered.className = 'delivered';
            statusBackLater.className = 'backLater';
            statusReturn.className = 'return';
            statusDeliveryProgress.className = 'deliveryProgress';

            statusDelivered.setAttribute('style', "width:" + request.delivered);
            statusBackLater.setAttribute('style', "width:" + request.backLater);
            statusReturn.setAttribute('style', "width:" + request.returnStops);
            statusDeliveryProgress.innerHTML = request.deliveryProgress;

            statusContent.appendChild(statusDelivered);
            statusContent.appendChild(statusBackLater);
            statusContent.appendChild(statusReturn);
            statusContent.appendChild(statusDeliveryProgress);
            div.appendChild(getRouteDetailItem(Monet.I18n.getResourcesByKey('Map.Popup.Truck.Status') + ':', statusContent));

            if (request.currentArrivals.length > 0) {
                div.appendChild(getBrClearAll());
                appendStrongSpan('Map.Popup.Truck.Customers');
                div.appendChild(document.createElement("hr"));
                div.appendChild(getRouteDetailItem(Monet.I18n.getResourcesByKey('Map.Popup.Truck.CustomerRoute') + ':', '...'));
                div.appendChild(getRouteDetailItem(Monet.I18n.getResourcesByKey('Map.Popup.Truck.CustomerOrganization') + ':', '...'));
                div.appendChild(getRouteDetailItem(Monet.I18n.getResourcesByKey('Map.Popup.Truck.CustomerDate') + ':', '...'));
            }

            div.appendChild(getBrClearAll());
        }

        appendStrongSpan('Map.Popup.Truck.Vehicle');
        div.appendChild(document.createElement("hr"));

        const equipmentUrl =
          '#/TrackEquipmentMapsDisplay/' + request.equipment.id;
        const isShowingEquipment = window.location.hash?.includes(equipmentUrl);
        const content = isShowingEquipment
          ? marker.equipmentKey
          : getLink(
              'linkToEquipment',
              equipmentUrl,
              marker.equipmentKey,
              () => {}
            );
        div.appendChild(
          getRouteDetailItem(
            Monet.I18n.getResourcesByKey('Map.Popup.Truck.VehicleKey') + ':',
            content
          )
        );

        div.appendChild(getRouteDetailItem(`${Monet.I18n.getResourcesByKey('Map.Popup.Truck.VehicleSpeed')}:`, velocityKm));
        div.appendChild(getRouteDetailItem(`${Monet.I18n.getResourcesByKey('RouteDetail.PopUp.timeCoord')}:`, Monet.Format.DateTime.formatToLocale(marker.date)));
        div.appendChild(getRouteDetailItem(`${Monet.I18n.getResourcesByKey('driver.latitude')}:`, lat));
        div.appendChild(getRouteDetailItem(`${Monet.I18n.getResourcesByKey('driver.longitude')}:`, lng));

        const { positionSource } = marker || {};
        if (positionSource) {
					let sourceLabel = getPositionSourceName(positionSource);

					if (sourceLabel) {
            div.title = sourceLabel;
            div.appendChild(
              getRouteDetailItem(
                `${Monet.I18n.getResourcesByKey('position.source.label')}:`,
                sourceLabel
              )
            );
					}
        }

        if (driversInfo && driversInfo.length > 0) {

            div.appendChild(getBrClearAll());
            appendStrongSpan('Map.Popup.Truck.DriversInfo');
            div.appendChild(document.createElement("hr"));

            for (var i = 0; i < driversInfo.length; i++) {
                var divPhoneContent = document.createElement('div');
                var nameDriver = document.createElement('div');
                var emptyPhonePopupMap = document.createElement('div');
                var driverNameContent = document.createElement('div');

                divPhoneContent.className = 'label labelDriver';
                nameDriver.className = 'nameDriver';
                nameDriver.innerHTML = driversInfo[i].name;
                emptyPhonePopupMap.id = "phonePopupMap";

                divPhoneContent.appendChild(nameDriver);
                divPhoneContent.appendChild(emptyPhonePopupMap);

                driverNameContent.className = "content";
                driverNameContent.title = driversInfo[i].phones;
                driverNameContent.innerHTML = driversInfo[i].phones;

                div.appendChild(divPhoneContent);
                div.appendChild(driverNameContent);

            }


        }

        if (telematicList && telematicList.length) {

            div.appendChild(getBrClearAll());
            appendStrongSpan('Map.Popup.Truck.TelematicInfo');
            div.appendChild(document.createElement("hr"));

            for (var j = 0; j < telematicList.length; j++) {

                var telematic = getRouteDetailItem(telematicList[j].description, telematicList[j].value);
                telematic.querySelector('.content').setAttribute('title', telematicList[j].value);
                div.appendChild(telematic);

            }

        }

        return div;

    }
};
